export default {"src":"/_next/static/media/ETH.a97aee09.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};